module.exports = __webpack_public_path__ + "img/4.7aece49f.png";